export default __webpack_public_path__ + "static/media/benjamin.50a7bb70.jpg";